export function sendMetaSearchEvent(event: IMetaSearchEvent): void {
    const isMetaPixelAvailable = 
        typeof window.fbq !== 'undefined' &&
        typeof window.fbq === 'function';

    if (isMetaPixelAvailable) {
        window.fbq('track', 'Search', event);
    }
}

export function sendTikTokSearchEvent(event: ITikTokSearchEvent): void {
    const isTikTokPixelAvailable =
        typeof window.ttq !== 'undefined' &&
        typeof window.ttq.track === 'function';

    if (isTikTokPixelAvailable) {
        window.ttq.track('Search', event);
    }
}

export interface IMetaSearchEvent {
    search_string: string; // search term
    content_ids: string[]; // default salesArticleNos
}

export interface ITikTokSearchEvent {
    contents: ITikTokContentItem[];
    value?: number; // should be 0 or be omitted
    currency: string; // iso code
    search_string: string; // search term
}

export interface ITikTokContentItem {
    content_id: string; // default salesArticleNo or fscode
    content_type: string; // should be "product"
    content_name: string; // sales designation
    content_category: string; // navigation key
    num_items: number; // should be 1
    value: string; // gross price
}
